import { Outlet } from "react-router-dom";
import { useState } from "react";

import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import SideNavbar from "../components/Layout/SideNavbar";
import MobileBottomNavbar from "../components/Layout/MobileBottomNavbar";
import GlobalAuthLoader from "../components/Login/GlobalAuthLoader";
import ScrollToTop from "../components/Common/ScrollToTop";
import PlayerCoordinator from "../components/Common/PlayerCoordinator";

import useSessionMonitor from "../hooks/useSessionMonitor";
import SupremeEditsPlayer from "../components/Player/SupremeEditsPlayer";
import { SupremeEditsProvider } from "../contexts/SupremeEditsContext";
import { LoggedUserProvider } from "../contexts/LoggedUserContext";
import PreviewPlayer from "../components/ProducerPack/PreviewPlayer";
import { PreviewPlayerProvider } from "../contexts/PreviewPlayerContext";

const Root = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useSessionMonitor();

  return (
    <div className="min-h-screen w-full bg-[#0A0A0A] bg-black-blue-radial bg-fixed bg-no-repeat bg-cover text-white">
      <LoggedUserProvider>
        <GlobalAuthLoader />
        <PreviewPlayerProvider>
          <SupremeEditsProvider>
            {/* Player coordinator manages single active player */}
            <PlayerCoordinator />
            <div className="flex">
              <SideNavbar
                isOpen={isSidebarOpen}
                onClose={() => setIsSidebarOpen(false)}
              />
              <MobileBottomNavbar />
              <main className="flex-1 overflow-y-auto lg:pl-[250px] xl:pl-[252px] pt-[60px] sm:pt-[64px] lg:pt-[80px] pb-[150px] sm:pb-[130px]">
                <Navbar toggleSidebar={() => setIsSidebarOpen(true)} />
                <ScrollToTop />
                <div className=" min-[1800px]:max-w-[1648px] mx-auto ">
                <Outlet />
                </div>

                {/* Bg Layers */}
                <div
                  className="pointer-events-none fixed bottom-0 left-1/2 -translate-x-1/2 w-[80vw] h-[100px] rounded-full blur-[100px] opacity-40 z-0"
                  style={{ backgroundColor: "rgba(25, 122, 208, 0.9)" }}
                />
                <div
                  className="pointer-events-none fixed bottom-0 left-[5%] w-[30vw] max-w-[414px] h-[100px] rounded-full blur-[118px] opacity-30 z-0"
                  style={{ backgroundColor: "rgba(82, 250, 240, 0.7)" }}
                />
              </main>
            </div>
            <div className="relative z-10 overflow-y-auto lg:pl-[250px] xl:pl-[252px]">
              <div className="min-[1800px]:max-w-[1648px] mx-auto px-4 sm:px-6 lg:px-8">
              <Footer />
              </div>
            </div>
            <SupremeEditsPlayer />
            <PreviewPlayer />
          </SupremeEditsProvider>
        </PreviewPlayerProvider>
      </LoggedUserProvider>
    </div>
  );
};

export default Root;
